module.exports = __webpack_public_path__ + "media/images/badge-member-33479820a4a224dd3e016eb862bfd86c.png";